<script lang="ts">
	import { format } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';
	import { Button, ButtonV2, Container, Icon, Text } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';

	export let showAboutAIModelModal = false,
		requiredHours,
		useNewLayout = false;

	const dispatch = createEventDispatcher();

	$: ButtonC = useNewLayout ? ButtonV2 : Button;
</script>

<Container backgroundColor={useNewLayout ? 'color-0' : undefined}>
	<div class="content-background">
		<div class="mb-m">
			<div class="mb-s d-flex align-items-center">
				<Icon class="mr-s" icon="fak fa-solid-sparkles icon-ai-color" size="s" />
				<Text element="p" styleType="body-small" class="text-bold">
					{capFirstChar($format('about_ai_model', { default: 'About AI Model' }))}</Text
				>
			</div>
			<div>
				<Text element="p" styleType="body-extra-small" class="text-color-muted">
					{@html $format('enhance_your_device_performance_with_ai', {
						default:
							'Enhance your device performance with AI model for <b>early issue detection and automated notifications<b>.',
					})}
					<Text
						element="span"
						styleType="body-extra-small"
						class="text-primary cursor-pointer"
						on:click={() => {
							showAboutAIModelModal = true;
						}}>{capFirstChar($format('link_learn_more', { default: 'Learn more' }))}</Text
					>
				</Text>
			</div>
		</div>
		<div class="mb-m">
			<div class="mb-s d-flex align-items-center">
				<Icon class="mr-s" icon="fas fa-screwdriver-wrench icon-ai-color" size="s" />
				<Text element="p" styleType="body-small" class="text-bold">
					{$format('ai_model_training', { default: 'AI Model training' })}</Text
				>
			</div>
			<div>
				<Text element="p" styleType="body-extra-small" class=" text-color-muted">
					{@html $format('ai_model_requires_training', {
						default: `The AI model requires a ${requiredHours}-hour training period to learn your device's usage patterns by analyzing its consumption and working behavior.`,
						values: { requiredHours: requiredHours },
					})}
				</Text>
			</div>
		</div>
		<div>
			<svelte:component
				this={ButtonC}
				size="m"
				width="full"
				variant="primary"
				on:click={() => {
					dispatch('startTraining');
				}}
			>
				{capFirstChar(
					$format('start_ai_model_training', {
						default: 'Start AI Model training',
					}),
				)}
			</svelte:component>
		</div>
	</div>
</Container>
